import React, {useEffect, useState} from 'react';
import {PanelWrapper} from "../../../components";
import {Link} from "react-router-dom";
import {EditProfileWrapper, ProfileImage} from "../MyShiftInfo/my-shift-info.styles";
import {CheckBox, FileInput, TextInput} from "../../../core-ui";
import {BorderLeftESS} from "../../SignUp/sign-up.styles";
import {fetchData} from "../../../helpers/general-function";
import Notification from "../../../helpers/notifications";
import {IMAGE_URL_BASE} from "../../../helpers/general-variables";
import {UserStatistics} from "./my-account.styles";

const isBase64 = require('is-base64');

const formParams = {
    avatar: {value: '', file: null},
    name: '',
    identification_code: '',
    mobile: '',
    email: '',
    type: 'student',
    license: {value: '', file: null},
    accentLicense: '',
    code: '',
};

const rateParams = {
    accepted_shift_requests: '0',
    mean_rate: '0',
    shifts_count: '0'
}

const MyAccount = () => {

    let [memoData, setMemoData] = useState(formParams);
    const [profileValues, setProfileValues] = useState(formParams);
    const [rateData, setRateData] = useState(rateParams);

    useEffect(() => {
        (async () => {
            const data = await fetchData('panel/profile', 'get', {}, true);

            if (data) {
                setMemoData(prevState => ({
                    ...prevState, ...data.user,
                    avatar: {value: data.user.avatar, file: null},
                    license: {value: '', file: null},
                    accentLicense: data.user.license,
                }));
                setProfileValues(prevState => ({
                    ...prevState, ...data.user,
                    avatar: {value: data.user.avatar, file: null},
                    license: {value: '', file: null},
                    accentLicense: data.user.license,
                }));

                setRateData({
                    accepted_shift_requests: data.accepted_shift_requests,
                    mean_rate: data.mean_rate,
                    shifts_count: data.shifts_count
                })
            }
        })();
    }, []);

    const changeHandler = ({target: {value, name, files}}) => {
        if (name === 'avatar') {
            const file = files[0];
            const reader = new FileReader();
            const url = reader.readAsDataURL(file);

            reader.onloadend = function (e) {
                setProfileValues(prevStates => ({...prevStates, [name]: {value: reader.result, file: files[0]}}));
            };

            return false;
        }

        if (files) {
            setProfileValues(prevStates => ({...prevStates, [name]: {value, file: files[0]}}));
        } else {
            setProfileValues(prevStates => ({...prevStates, [name]: value}));
        }
    }

    const sendProfileEdits = async () => {
        const currentParams = {
            ...profileValues,
            license: profileValues.license.file ? profileValues.license.file : '',
            avatar: profileValues.avatar.file ? profileValues.avatar.file : ''
        };

        console.log(memoData)

        if(memoData.type === 'employee' && currentParams.type === 'student') {
            Notification.danger('تغییر نوع کاربری به دانشجو ممکن نیست');
            return false;
        } else if(memoData.type === currentParams.type) {
            delete currentParams.type;
        }

        if (!currentParams.avatar) {
            delete currentParams.license;
        }

        if (!currentParams.license) {
            delete currentParams.license;
        }

        const data = await fetchData('panel/profile/edit', 'post', currentParams, true, {
            existFile: true
        });

        if (data) {
            Notification.success('اطلاعات با موفقیت ویرایش شد');
            setMemoData({...profileValues});
        } else {
            setProfileValues({...memoData});
        }
    }

    return (
        <PanelWrapper activeRouteData={{icon: 'icon-personalcard', name: 'اطلاعات حساب کاربری'}}>
            <div className='text-start d-none d-lg-block'>
                <Link to='/panel/my-requests' className='c-link-gray'>
                    بازگشت به صفحه نخست
                    <div className='d-inline-block me-2' style={{transform: 'rotateZ(180deg)'}}>
                        <i className='icon-arrow-circle-right align-middle'/>
                    </div>
                </Link>
            </div>
            <div className='mx-lg-5'>
                <input className='d-none' type='file' id='avatar' name='avatar' onChange={changeHandler}/>
                <ProfileImage htmlFor='avatar'>
                    <div>
                        <img
                            src={profileValues.avatar.value ? (isBase64(profileValues.avatar.value, {allowMime: true}) ? profileValues.avatar.value : IMAGE_URL_BASE+profileValues.avatar.value) : 'https://s9.favim.com/orig/130820/beautiful-beauty-girl-hot-Favim.com-864943.jpg'}
                            alt='avatar'/>
                    </div>
                    <EditProfileWrapper>
                        <div className='d-flex align-items-center justify-content-center'>
                            <i className='icon-edit-2'/>
                        </div>
                    </EditProfileWrapper>
                </ProfileImage>
                <p className='text-center mt-3 dark-gray fs-6'>دکتر {profileValues.name}</p>
                <p className='text-center gray-color fs-9'>{profileValues.type === 'student' ? 'دانشجو' : 'داروساز'}</p>

                <div className='mt-c-4 d-flex flex-wrap align-items-center justify-content-between mx-lg-4'>
                    <UserStatistics className='text-center'>
                        <h1 className='success-color fs-2'>{rateData.shifts_count}</h1>
                        <p className='sky-color fs-8'>شیفت‌های ثبتی</p>
                    </UserStatistics>
                    <UserStatistics className='text-center'>
                        <h1 className='success-color fs-2'>{rateData.mean_rate}%</h1>
                        <p className='sky-color fs-8'>میزان رضایت</p>
                    </UserStatistics>
                    <UserStatistics className='text-center'>
                        <h1 className='success-color fs-2'>{rateData.accepted_shift_requests}</h1>
                        <p className='sky-color fs-8'>شیفت‌های پذیرفته</p>
                    </UserStatistics>
                </div>
                <div className='horizontal-line mt-c-4'/>

                <div className='mx-lg-4'>
                    <div className='row mt-c-4'>
                        <div className='col-12 col-xl-6'>
                            <TextInput wrapperClassNames='ms-xl-4'
                                       iconName='icon-user'
                                       onChange={changeHandler} value={profileValues.name}
                                       id='name' name='name' placeholder='نام و نام خانوادگی'/>
                        </div>
                        <div className='col-12 col-xl-6 mt-c-2_5 mt-xl-0'>
                            <TextInput wrapperClassNames='me-xl-4' onChange={changeHandler}
                                       value={profileValues.identification_code} id='identification_code'
                                       iconName='icon-barcode'
                                       name='identification_code' placeholder='کد ملی'/>
                        </div>
                    </div>
                    <div className='row mt-xl-5'>
                        <div className='col-12 col-xl-6'>
                            <TextInput wrapperClassNames='ms-xl-4' onChange={changeHandler}
                                       value={profileValues.mobile}
                                       iconName='icon-call'
                                       id='mobile' name='mobile' placeholder='تلفن همراه'/>
                        </div>
                        <div className='col-12 col-xl-6 mt-c-2_5 mt-xl-0'>
                            <TextInput wrapperClassNames='me-xl-4' caption='(اختیاری)'
                                       onChange={changeHandler} iconName='icon-sms'
                                       value={profileValues.email} id='email' name='email' placeholder='ایمیل'/>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='row justify-content-center w-100 mt-4 mt-lg-6'>
                        <BorderLeftESS className='col-6 col-lg-4 py-lg-3'>
                            <CheckBox onChange={changeHandler}
                                      iconName='icon-user-edit'
                                      iconEnd
                                      value='student'
                                      name='type'
                                      id='student'
                                      classNames='me-auto ms-lg-4'
                                      checked={profileValues.type === 'student'}
                                      label='درحال تحصیل هستم'/>
                        </BorderLeftESS>
                        <div className='col-6 col-lg-4 py-lg-3'>
                            <CheckBox onChange={changeHandler}
                                      disabled
                                      iconName='icon-user-tick'
                                      value='employee'
                                      name='type'
                                      classNames='me-lg-4'
                                      id='employee'
                                      checked={profileValues.type === 'employee'}
                                      label='فارغ‌التحصیل هستم'/>
                        </div>
                    </div>
                    <div className='text-center mt-c-4'>
                        <p className='dark-gray'>تصویر شما با موفقیت آپلود و تایید شده است.</p>
                        <FileInput label='انتخاب فایل'
                                   value={profileValues.license.value}
                                   accentFileName={profileValues.accentLicense}
                                   name='license'
                                   onChange={changeHandler}
                                   parentClassNames='mt-4'
                                   id='license'/>
                    </div>
                    <div className='d-flex justify-content-center mt-c-4'>
                        <button className='c-btn c-btn-success flex-grow-1 flex-lg-grow-0 py-c-2 px-5' onClick={sendProfileEdits}>ثبت ویرایشات</button>
                    </div>
                </div>
            </div>
        </PanelWrapper>
    );
};

export default MyAccount;
